import styled from 'styled-components'

const Style = {
	Wrapper: styled.div`
		width: 100%;
		min-height: 100dvh;
		background-color: #f5f5f5;
	`,

	LoadingWrapper: styled.div`
		display: flex;
		justify-content: center;
		align-items: center;
		height: 400px;

		div {
			font-size: 18px;
			color: #666;
		}
	`,

	ContentDiv: styled.div`
		max-width: 1200px;
		margin: 0 auto;
		padding: 20px;
		display: flex;
		flex-direction: column;
		gap: 24px;
	`,

	Section: styled.div`
		background: white;
		border-radius: 8px;
		padding: 24px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

		h2 {
			margin: 0 0 16px 0;
			font-size: 20px;
			font-weight: 600;
			color: #333;
			border-bottom: 2px solid #007bff;
			padding-bottom: 8px;
		}
	`,

	InfoGrid: styled.div`
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
		gap: 16px;
		margin-top: 16px;
	`,

	InfoItem: styled.div`
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 12px 16px;
		background: #f8f9fa;
		border-radius: 6px;
		border-left: 4px solid #007bff;
	`,

	InfoLabel: styled.span`
		font-weight: 500;
		color: #555;
		font-size: 14px;
	`,

	InfoValue: styled.span`
		font-weight: 600;
		color: #333;
		font-size: 14px;
		font-family: 'Courier New', monospace;
	`,

	DataDisplay: styled.div`
		background: #f8f9fa;
		border: 1px solid #e9ecef;
		border-radius: 6px;
		padding: 16px;
		margin-top: 16px;
		overflow-x: auto;

		pre {
			margin: 0;
			font-size: 12px;
			font-family: 'Monaco', 'Consolas', 'Courier New', monospace;
			color: #333;
			line-height: 1.5;
			white-space: pre-wrap;
			word-wrap: break-word;
		}
	`,

	TestSection: styled.div`
		background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
		color: white;
		border-radius: 8px;
		padding: 24px;
		box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

		h2 {
			margin: 0 0 16px 0;
			font-size: 20px;
			font-weight: 600;
			color: white;
			border-bottom: 2px solid rgba(255, 255, 255, 0.3);
			padding-bottom: 8px;
		}
	`,

	TestButton: styled.button`
		background: rgba(255, 255, 255, 0.2);
		border: 2px solid rgba(255, 255, 255, 0.5);
		color: white;
		padding: 12px 24px;
		border-radius: 6px;
		font-size: 14px;
		font-weight: 500;
		cursor: pointer;
		transition: all 0.3s ease;

		&:hover {
			background: rgba(255, 255, 255, 0.3);
			border-color: rgba(255, 255, 255, 0.7);
			transform: translateY(-2px);
		}

		&:active {
			transform: translateY(0);
		}
	`,
}

export default Style
